import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutFounderSectionConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-about-founder-section',
  standalone: false,
  templateUrl: './about-founder-section.component.html',
  styleUrls: ['./about-founder-section.component.scss']
})
export class AboutFounderSectionComponent {
  @Input() section: AboutFounderSectionConfig | null = null;
}
